<router-outlet></router-outlet>
<app-loader></app-loader>

<!-- Botón flotante de WhatsApp con label -->
<a href="https://wa.me/59175113859?text=Hola%20Tekne%2C%20soy%20cliente%20mayor%20y%20tengo%20una%20consulta"
  target="_blank" class="whatsapp-float d-flex align-items-center" *ngIf="appConfig.isVipMode">
  <span class="whatsapp-label me-2">¿Necesita ayuda?</span>
  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" width="40" height="40">
</a>
